export interface IconTypes {
  attach: React.FC;
  attachCamera: React.FC;
  attachContacts: React.FC;
  attachDocument: React.FC;
  attachImage: React.FC;
  attachRooms: React.FC;
  block: React.FC;
  back: React.FC;
  backNew: React.FC;
  cancel: React.FC;
  chat: React.FC;
  check: React.FC;
  delete: React.FC;
  doubleTick: React.FC;
  downArrow: React.FC;
  emojiActivity: React.FC;
  emojiFlags: React.FC;
  emojiFood: React.FC;
  emojiNature: React.FC;
  emojiObjects: React.FC;
  emojiPeople: React.FC;
  emojiSymbols: React.FC;
  emojiTravel: React.FC;
  gif: React.FC;
  laptop: React.FC;
  lock: React.FC;
  menu: React.FC;
  microphone: React.FC;
  notification: React.FC;
  noWifi: React.FC;
  pinned: React.FC;
  recent: React.FC;
  rightArrow: React.FC;
  search: React.FC;
  send: React.FC;
  singleTick: React.FC;
  smiley: React.FC;
  status: React.FC;
  sticker: React.FC;
  thumbsDown: React.FC;
  whatsapp: React.FC;
  chatapp: React.FC;
  circularLoader: React.FC;
  closeIcon: React.FC;
  downloadAsset: React.FC;
  showTemplate: React.FC;
  like: React.FC;
  activeLike: React.FC;
  dislike: React.FC;
  activeDislike: React.FC;
  sendIcon: React.FC;
  activeSendIcon: React.FC;
  doubleDownArrow: React.FC;
  greyCross: React.FC;
  download: React.FC;
  redirect: React.FC;
  websiteBack: React.FC;
}

const icons: IconTypes = {
  attach: (props) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      width="24"
      height="24"
      {...props}
    >
      <path
        fill="currentColor"
        d="M1.816 15.556v.002c0 1.502.584 2.912 1.646 3.972s2.472 1.647 3.974 1.647a5.58 5.58 0 0 0 3.972-1.645l9.547-9.548c.769-.768 1.147-1.767 1.058-2.817-.079-.968-.548-1.927-1.319-2.698-1.594-1.592-4.068-1.711-5.517-.262l-7.916 7.915c-.881.881-.792 2.25.214 3.261.959.958 2.423 1.053 3.263.215l5.511-5.512c.28-.28.267-.722.053-.936l-.244-.244c-.191-.191-.567-.349-.957.04l-5.506 5.506c-.18.18-.635.127-.976-.214-.098-.097-.576-.613-.213-.973l7.915-7.917c.818-.817 2.267-.699 3.23.262.5.501.802 1.1.849 1.685.051.573-.156 1.111-.589 1.543l-9.547 9.549a3.97 3.97 0 0 1-2.829 1.171 3.975 3.975 0 0 1-2.83-1.173 3.973 3.973 0 0 1-1.172-2.828c0-1.071.415-2.076 1.172-2.83l7.209-7.211c.157-.157.264-.579.028-.814L11.5 4.36a.572.572 0 0 0-.834.018l-7.205 7.207a5.577 5.577 0 0 0-1.645 3.971z"
      ></path>
    </svg>
  ),
  attachCamera: (props) => (
    <span
      data-testid="attach-camera"
      data-icon="attach-camera"
      className="_1SWzr"
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
        viewBox="0 0 53 53"
        width="53"
        height="53"
        {...props}
      >
        <defs>
          <circle id="camera-SVGID_1_" cx="26.5" cy="26.5" r="25.5"></circle>
        </defs>
        <clipPath id="camera-SVGID_2_">
          <use xlinkHref="#camera-SVGID_1_" overflow="visible"></use>
        </clipPath>
        <g clipPath="url(#camera-SVGID_2_)">
          <path
            fill="#D3396D"
            d="M26.5-1.1C11.9-1.1-1.1 5.6-1.1 27.6h55.2c-.1-19-13-28.7-27.6-28.7z"
          ></path>
          <path
            fill="#EC407A"
            d="M53 26.5H-1.1c0 14.6 13 27.6 27.6 27.6s27.6-13 27.6-27.6H53z"
          ></path>
          <path fill="#D3396D" d="M17 24.5h15v9H17z"></path>
        </g>
        <g fill="#F5F5F5">
          <path
            id="svg-camera"
            d="M27.795 17a3 3 0 0 1 2.405 1.206l.3.403a3 3 0 0 0 2.405 1.206H34.2a2.8 2.8 0 0 1 2.8 2.8V32a4 4 0 0 1-4 4H20a4 4 0 0 1-4-4v-9.385a2.8 2.8 0 0 1 2.8-2.8h1.295a3 3 0 0 0 2.405-1.206l.3-.403A3 3 0 0 1 25.205 17h2.59zM26.5 22.25a5.25 5.25 0 1 0 .001 10.501A5.25 5.25 0 0 0 26.5 22.25zm0 1.75a3.5 3.5 0 1 1 0 7 3.5 3.5 0 0 1 0-7z"
          ></path>
        </g>
      </svg>
    </span>
  ),
  attachContacts: (props) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      viewBox="0 0 53 53"
      width="53"
      height="53"
      {...props}
    >
      <defs>
        <circle id="contact-SVGID_1_" cx="26.5" cy="26.5" r="25.5"></circle>
      </defs>
      <clipPath id="contact-SVGID_2_">
        <use xlinkHref="#contact-SVGID_1_" overflow="visible"></use>
      </clipPath>
      <g clipPath="url(#contact-SVGID_2_)">
        <path
          fill="#0795DC"
          d="M26.5-1.1C11.9-1.1-1.1 5.6-1.1 27.6h55.2c-.1-19-13-28.7-27.6-28.7z"
        ></path>
        <path
          fill="#0EABF4"
          d="M53 26.5H-1.1c0 14.6 13 27.6 27.6 27.6s27.6-13 27.6-27.6H53z"
        ></path>
      </g>
      <g fill="#F5F5F5">
        <path
          id="svg-contact"
          d="M26.5 26.5A4.5 4.5 0 0 0 31 22a4.5 4.5 0 0 0-4.5-4.5A4.5 4.5 0 0 0 22 22a4.5 4.5 0 0 0 4.5 4.5zm0 2.25c-3.004 0-9 1.508-9 4.5v1.125c0 .619.506 1.125 1.125 1.125h15.75c.619 0 1.125-.506 1.125-1.125V33.25c0-2.992-5.996-4.5-9-4.5z"
        ></path>
      </g>
    </svg>
  ),
  attachDocument: (props) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      viewBox="0 0 53 53"
      width="53"
      height="53"
      {...props}
    >
      <defs>
        <circle id="document-SVGID_1_" cx="26.5" cy="26.5" r="25.5"></circle>
      </defs>
      <clipPath id="document-SVGID_2_">
        <use xlinkHref="#document-SVGID_1_" overflow="visible"></use>
      </clipPath>
      <g clipPath="url(#document-SVGID_2_)">
        <path
          fill="#5157AE"
          d="M26.5-1.1C11.9-1.1-1.1 5.6-1.1 27.6h55.2c-.1-19-13-28.7-27.6-28.7z"
        ></path>
        <path
          fill="#5F66CD"
          d="M53 26.5H-1.1c0 14.6 13 27.6 27.6 27.6s27.6-13 27.6-27.6H53z"
        ></path>
      </g>
      <g fill="#F5F5F5">
        <path
          id="svg-document"
          d="M29.09 17.09c-.38-.38-.89-.59-1.42-.59H20.5c-1.1 0-2 .9-2 2v16c0 1.1.89 2 1.99 2H32.5c1.1 0 2-.9 2-2V23.33c0-.53-.21-1.04-.59-1.41l-4.82-4.83zM27.5 22.5V18l5.5 5.5h-4.5c-.55 0-1-.45-1-1z"
        ></path>
      </g>
    </svg>
  ),
  attachImage: (props) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      viewBox="0 0 53 53"
      width="53"
      height="53"
      {...props}
    >
      <defs>
        <circle id="image-SVGID_1_" cx="26.5" cy="26.5" r="25.5"></circle>
      </defs>
      <clipPath id="image-SVGID_2_">
        <use xlinkHref="#image-SVGID_1_" overflow="visible"></use>
      </clipPath>
      <g clipPath="url(#image-SVGID_2_)">
        <path
          fill="#AC44CF"
          d="M26.5-1.1C11.9-1.1-1.1 5.6-1.1 27.6h55.2c-.1-19-13-28.7-27.6-28.7z"
        ></path>
        <path
          fill="#BF59CF"
          d="M53 26.5H-1.1c0 14.6 13 27.6 27.6 27.6s27.6-13 27.6-27.6H53z"
        ></path>
        <path fill="#AC44CF" d="M17 24.5h18v9H17z"></path>
      </g>
      <g fill="#F5F5F5">
        <path
          id="svg-image"
          d="M18.318 18.25h16.364c.863 0 1.727.827 1.811 1.696l.007.137v12.834c0 .871-.82 1.741-1.682 1.826l-.136.007H18.318a1.83 1.83 0 0 1-1.812-1.684l-.006-.149V20.083c0-.87.82-1.741 1.682-1.826l.136-.007h16.364zm5.081 8.22l-3.781 5.044c-.269.355-.052.736.39.736h12.955c.442-.011.701-.402.421-.758l-2.682-3.449a.54.54 0 0 0-.841-.011l-2.262 2.727-3.339-4.3a.54.54 0 0 0-.861.011zm8.351-5.22a1.75 1.75 0 1 0 .001 3.501 1.75 1.75 0 0 0-.001-3.501z"
        ></path>
      </g>
    </svg>
  ),
  attachRooms: (props) => (
    <svg
      id="Layer_1"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      viewBox="0 0 53 53"
      width="53"
      height="53"
      {...props}
    >
      <defs>
        <circle id="rooms-SVGID_1_" cx="26.5" cy="26.5" r="25.5"></circle>
      </defs>
      <clipPath id="rooms-SVGID_2_">
        <use xlinkHref="#rooms-SVGID_1_" overflow="visible"></use>
      </clipPath>
      <g clipPath="url(#rooms-SVGID_2_)">
        <path
          fill="#396CD3"
          d="M26.5-1.1C11.9-1.1-1.1 5.6-1.1 27.6h55.2c-.1-19-13-28.7-27.6-28.7z"
        ></path>
        <path
          fill="#4079EC"
          d="M53 26.5H-1.1c0 14.6 13 27.6 27.6 27.6s27.6-13 27.6-27.6H53z"
        ></path>
        <path fill="#396CD3" d="M17 24.5h15v9H17z"></path>
      </g>
      <g fill="#F5F5F5">
        <path
          id="svg-rooms"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M28.5 18a3.5 3.5 0 0 1 3.5 3.5v10a3.5 3.5 0 0 1-3.5 3.5h-10a3.5 3.5 0 0 1-3.5-3.5v-10a3.5 3.5 0 0 1 3.5-3.5h10zm-7.925 6.782a.804.804 0 0 0-1.045-.073l-.708.698-.297.33-.134.177a4.075 4.075 0 0 0 .433 5.265 4.07 4.07 0 0 0 2.886 1.198c.976 0 1.952-.349 2.73-1.05l.784-.777.077-.091.063-.102.045-.105a.797.797 0 0 0-.189-.824.806.806 0 0 0-1.045-.073l-.704.694-.123.116-.147.119-.15.105a2.5 2.5 0 0 1-3.099-.337 2.492 2.492 0 0 1-.12-3.392l.748-.756.076-.091.063-.102.046-.105a.794.794 0 0 0-.19-.824zm5.281-.637a.803.803 0 0 0-1.044-.073l-3.67 3.662-.078.091-.063.102-.045.105a.793.793 0 0 0 .754 1.056.805.805 0 0 0 .481-.16l3.671-3.662.076-.09.064-.102.045-.105a.795.795 0 0 0-.191-.824zm2.323-2.323a4.078 4.078 0 0 0-5.615-.149l-.785.777-.073.084-.062.098a.806.806 0 0 0 .14.941.803.803 0 0 0 1.043.072l.705-.693.127-.119.137-.111a2.494 2.494 0 0 1 3.257.227c.921.923.972 2.413.117 3.392l-.746.755-.072.084-.062.098a.8.8 0 0 0 .139.941.8.8 0 0 0 1.043.072l.709-.697.148-.156.145-.17a4.084 4.084 0 0 0-.295-5.446zm9.815-.188l.006.129v9.474c0 1.31-1.714 1.998-2.744 1.12l-.878-.847a2.828 2.828 0 0 1-.871-1.849l-.007-.19v-5.943c0-.765.316-1.498.879-2.039l.877-.846c.996-.848 2.631-.234 2.738.991z"
        ></path>
      </g>
    </svg>
  ),
  back: (props) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      width="24"
      height="24"
      {...props}
    >
      <path
        fill="currentColor"
        d="M12 4l1.4 1.4L7.8 11H20v2H7.8l5.6 5.6L12 20l-8-8 8-8z"
      ></path>
    </svg>
  ),
  backNew: (props) => (
    <svg aria-hidden="true" viewBox="0 0 24 24" {...props}>
      <path d="M15.41 7.41 14 6l-6 6 6 6 1.41-1.41L10.83 12z"></path>
    </svg>
  ),
  block: (props) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      width="24"
      height="24"
      {...props}
    >
      <path
        fill="currentColor"
        d="M12 2.8c-5.3 0-9.7 4.3-9.7 9.7s4.3 9.7 9.7 9.7 9.7-4.3 9.7-9.7-4.4-9.7-9.7-9.7zm-7.3 9.7c0-4 3.3-7.3 7.3-7.3 1.6 0 3.1.5 4.3 1.4L6.1 16.8c-.9-1.2-1.4-2.7-1.4-4.3zm7.3 7.3c-1.6 0-3-.5-4.2-1.4L17.9 8.3c.9 1.2 1.4 2.6 1.4 4.2 0 4-3.3 7.3-7.3 7.3z"
      ></path>
    </svg>
  ),
  cancel: (props) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      width="24"
      height="24"
      {...props}
    >
      <path
        fill="currentColor"
        d="M19.1 17.2l-5.3-5.3 5.3-5.3-1.8-1.8-5.3 5.4-5.3-5.3-1.8 1.7 5.3 5.3-5.3 5.3L6.7 19l5.3-5.3 5.3 5.3 1.8-1.8z"
      ></path>
    </svg>
  ),
  chat: (props) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      width="24"
      height="24"
      {...props}
    >
      <path
        fill="currentColor"
        d="M19.005 3.175H4.674C3.642 3.175 3 3.789 3 4.821V21.02l3.544-3.514h12.461c1.033 0 2.064-1.06 2.064-2.093V4.821c-.001-1.032-1.032-1.646-2.064-1.646zm-4.989 9.869H7.041V11.1h6.975v1.944zm3-4H7.041V7.1h9.975v1.944z"
      ></path>
    </svg>
  ),
  check: (props) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      id="check"
      viewBox="0 0 18 13"
      fill="none"
      {...props}
    >
      <path
        d="M6.99974 10.172L16.1917 0.979004L17.6067 2.393L6.99974 13L0.635742 6.636L2.04974 5.222L6.99974 10.172Z"
        fill="currentColor"
      ></path>
    </svg>
  ),
  delete: (props) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      width="24"
      height="24"
      {...props}
    >
      <path
        fill="currentColor"
        d="M6 18c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V6H6v12zM19 3h-3.5l-1-1h-5l-1 1H5v2h14V3z"
      ></path>
    </svg>
  ),
  doubleTick: (props) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 16 15"
      width="16"
      height="15"
      {...props}
    >
      <path
        fill="currentColor"
        d="M15.01 3.316l-.478-.372a.365.365 0 0 0-.51.063L8.666 9.879a.32.32 0 0 1-.484.033l-.358-.325a.319.319 0 0 0-.484.032l-.378.483a.418.418 0 0 0 .036.541l1.32 1.266c.143.14.361.125.484-.033l6.272-8.048a.366.366 0 0 0-.064-.512zm-4.1 0l-.478-.372a.365.365 0 0 0-.51.063L4.566 9.879a.32.32 0 0 1-.484.033L1.891 7.769a.366.366 0 0 0-.515.006l-.423.433a.364.364 0 0 0 .006.514l3.258 3.185c.143.14.361.125.484-.033l6.272-8.048a.365.365 0 0 0-.063-.51z"
      ></path>
    </svg>
  ),
  downArrow: (props) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 19 20"
      width="19"
      height="20"
      {...props}
    >
      <path
        fill="currentColor"
        d="M3.8 6.7l5.7 5.7 5.7-5.7 1.6 1.6-7.3 7.2-7.3-7.2 1.6-1.6z"
      ></path>
    </svg>
  ),
  emojiActivity: (props) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      width="24"
      height="24"
      {...props}
    >
      <path
        fill="currentColor"
        d="M14.8 15.3l1.3-3.8c.1-.2 0-.5-.2-.6l-3.3-2.4c-.2-.1-.5-.1-.6 0l-3.3 2.4c-.2.1-.3.4-.2.6l1.3 3.8c.1.2.3.4.5.4h4c.2 0 .4-.2.5-.4z"
      ></path>
      <path
        fill="currentColor"
        d="M12 1.9C6.4 1.9 1.9 6.4 1.9 12S6.4 22.1 12 22.1 22.1 17.6 22.1 12 17.6 1.9 12 1.9zM9.8 20.3c.1-.2.1-.4 0-.6l-1.4-2.3c-.1-.1-.2-.2-.4-.3l-2.5-.6c-.2-.1-.5.1-.6.2-.9-1.3-1.4-2.9-1.5-4.5.2 0 .4 0 .5-.2l1.7-2c.1 0 .2-.2.2-.3l-.3-2.6c0-.2-.1-.3-.3-.4C6.2 5.4 7.5 4.5 9 4c0 .1.2.3.3.3l2.5 1.1c.1.1.3.1.4 0l2.5-1.1.3-.3c1.5.6 2.7 1.5 3.7 2.7-.1.1-.2.2-.2.4l-.2 2.6c0 .2 0 .3.1.4l1.7 2c.1.1.3.2.4.2 0 1.6-.5 3.1-1.3 4.4-.1-.1-.2-.1-.4-.1l-2.5.6c-.1 0-.3.1-.4.3l-1.4 2.3c-.1.2-.1.3 0 .5-.8.2-1.6.4-2.5.4-.7-.1-1.5-.2-2.2-.4z"
      ></path>
    </svg>
  ),
  emojiFlags: (props) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      width="24"
      height="24"
      {...props}
    >
      <path
        fill="currentColor"
        d="M5.5 3.8v-.2c0-.3-.2-.5-.5-.5h-.5c-.3 0-.5.2-.5.5V21c0 .3.2.5.5.5H5c.3 0 .5-.2.5-.5v-6.2c5 1.8 9.3-2.7 14.5.6V4.1C14.9 1 10.3 5.6 5.5 3.8zm10.3 8.8c-1.4 0-2.8.3-4.1.6-1.2.3-2.4.5-3.5.5-.9 0-1.8-.2-2.6-.5V5.4c.8.2 1.5.3 2.3.3 1.5 0 2.9-.4 4.3-.7 1.3-.3 2.5-.6 3.8-.6.9 0 1.7.2 2.5.5V13c-.9-.2-1.8-.4-2.7-.4z"
      ></path>
    </svg>
  ),
  emojiFood: (props) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      width="24"
      height="24"
      {...props}
    >
      <path
        fill="currentColor"
        d="M7.4 11.4c-.4 0-.8.4-.8.8V14c0 .4.4.8.8.8s.8-.4.6-.8v-1.8c0-.6-.2-.8-.6-.8zM4.6 10.4c-.4 0-.8.4-.8.8V15c0 .4.4.8.8.8s.8-.4.8-.8v-3.8c0-.6-.4-.8-.8-.8z"
      ></path>
      <path
        fill="currentColor"
        d="M23 7.2c-.6-.6-1.6-.8-2.8-.6-.2 0-.4.2-.6.2V4.2c0-.6-.6-1.2-1.2-1.2h-17C.8 3 .2 3.6.2 4.2v7.4c0 5.4 3.2 9.6 8.4 9.6h2.2c4.2 0 7-2.6 8-6h.4c2.2-.4 4-2.6 4.4-4.8.4-1.4.2-2.4-.6-3.2zm-4.8-2.8v3H1.6v-3h16.6zM11 19.8H8.8c-5.2 0-7-4.4-7-8.2V8.8h16.6v2.8c-.2 4-2.4 8.2-7.4 8.2zm8.4-6.2c.2-.6.2-1.4.2-2V8.4c.4-.2.6-.4 1-.4.6-.2 1.2 0 1.4.4.4.4.6 1 .4 1.8-.2 1.4-1.6 3-3 3.4z"
      ></path>
    </svg>
  ),
  emojiNature: (props) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      width="24"
      height="24"
      {...props}
    >
      <path
        fill="currentColor"
        d="M7.2 12.2c.608 0 1.1.627 1.1 1.4S7.808 15 7.2 15s-1.1-.627-1.1-1.4.492-1.4 1.1-1.4zm9.7 0c.608 0 1.1.627 1.1 1.4s-.492 1.4-1.1 1.4-1.1-.627-1.1-1.4.492-1.4 1.1-1.4zm4.6-1.1l-1.2-2.4c.9-.4 1.7-1.3 2-2.2.3-.7.4-2.1-1-3.5-1-.9-2-1.2-2.9-1-1.1.3-1.9 1.2-2.3 1.9-1.4-.7-2.9-.8-4.1-.8-1.5 0-2.8.3-4 .9-.5-.9-1.2-1.8-2.3-2.1-1-.2-2 .1-2.9 1-1 1-1.4 2.2-1 3.4.4 1.1 1.2 1.9 2 2.3-.2.5-.4 1-.6 1.6l-.2.2c-.3.7-.5 1.3-.8 1.9-.4 1-.9 1.9-.9 3.1 0 1.6.8 6.7 10.5 6.7 3.8 0 6.6-.7 8.5-2.2s2.2-3.4 2.2-4.3c.2-2.1-.2-2.9-1-4.5zm-2.7-7.6c.4-.1.9.1 1.5.6.6.6.8 1.2.6 1.8-.2.6-.7 1.1-1.2 1.3-.6-1.2-1.3-2-2.1-2.6.2-.4.6-1 1.2-1.1zM3.3 5.9c-.2-.6 0-1.2.6-1.8.5-.5 1.1-.7 1.5-.6.5.1 1.1.7 1.3 1.2-.9.7-1.6 1.5-2.2 2.6C4 7 3.4 6.5 3.3 5.9zm17.8 9.7c0 .7-.2 2-1.6 3.1-1.5 1.2-4.1 1.8-7.5 1.8-8.3 0-8.9-3.9-8.9-5.1 0-.8.3-1.5.7-2.4.3-.6.6-1.2.8-2.1l.1-.2c.5-1.5 2-6.2 7.3-6.2 1.2 0 2.5.2 3.7.9.1.1.5.3.5.3.9.7 1.7 1.7 2.4 3.2.6 1.3 1 2.2 1.4 2.9.8 1.6 1.1 2.1 1.1 3.8zM14.6 17c-.1.1-.6.4-1.2.3-.4-.1-.7-.3-.9-.8 0-.1-.1-.1-.1-.2.8-.1 1.3-.6 1.3-1.3s-.7 0-1.7 0c-.9 0-1.7-.7-1.7 0 0 .6.6 1.2 1.4 1.3l-.1.1c-.3.4-.5.7-.9.8-.5.1-1.1-.1-1.3-.3-.2-.2-.5-.1-.7.1s-.1.5.1.7c.1.1.8.5 1.6.5.2 0 .4 0 .5-.1.4-.1.8-.3 1.1-.7.4.4.9.6 1.2.7.8.2 1.7-.2 2-.5.2-.2.2-.5 0-.7-.1 0-.4-.1-.6.1z"
      ></path>
    </svg>
  ),
  emojiObjects: (props) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      width="24"
      height="24"
      {...props}
    >
      <path
        fill="currentColor"
        d="M18.8 6.7c-.9-2.6-3.2-4.6-6-4.9h-1.6c-2.8.3-5.1 2.2-6 4.9-1 3 .1 6.2 2.7 8H8c.2.1.3.4.3.6v2c0 .8.6 1.4 1.4 1.4h4.6c.8 0 1.4-.6 1.4-1.4v-2c0-.2.1-.5.3-.6l.1-.1c2.5-1.8 3.6-5 2.7-7.9zm-3.5 6.9l-.1.1c-.5.4-.9 1-.9 1.7v2s0 .1-.1.1H9.8s-.1 0-.1-.1v-2c0-.7-.3-1.3-.9-1.7l-.1-.1c-2-1.4-3-4-2.2-6.5.7-2.1 2.6-3.7 4.9-3.9H12.7c2.2.2 4.2 1.8 4.9 3.9.7 2.4-.2 5-2.3 6.5zM9.2 21.2c0 .6.5 1 1 1h3.7c.6 0 1-.5 1-1v-1H9.2v1z"
      ></path>
      <path
        fill="currentColor"
        d="M13.6 10.5c-.4 0-.8.3-.8.8 0 .1 0 .2.1.3-.2.3-.5.5-.8.5s-.6-.2-.8-.5c0-.1.1-.2.1-.3 0-.4-.3-.8-.8-.8-.4 0-.8.3-.8.8 0 .4.3.7.7.8.3.4.7.7 1.1.8V15c0 .2.2.4.4.4s.4-.2.4-.4v-2.1c.4-.1.8-.4 1.1-.8.4 0 .8-.3.8-.8s-.3-.8-.7-.8z"
      ></path>
    </svg>
  ),
  emojiPeople: (props) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      width="24"
      height="24"
      {...props}
    >
      <path
        fill="currentColor"
        d="M12 22.1C6.4 22.1 1.9 17.6 1.9 12S6.4 1.9 12 1.9 22.1 6.4 22.1 12 17.6 22.1 12 22.1zm0-18.6c-4.7 0-8.5 3.8-8.5 8.5s3.8 8.5 8.5 8.5 8.5-3.8 8.5-8.5-3.8-8.5-8.5-8.5z"
      ></path>
      <path
        fill="currentColor"
        d="M8.9 11.6c.7 0 1.3-.7 1.3-1.5s-.6-1.5-1.3-1.5-1.3.7-1.3 1.5.6 1.5 1.3 1.5zM17.1 13.6c-1.1.1-3 .4-5 .4s-4-.3-5-.4c-.4 0-.6.3-.4.7 1.1 2 3.1 3.5 5.5 3.5 2.3 0 4.4-1.5 5.5-3.5.1-.3-.2-.7-.6-.7zM12.3 16c-2.6 0-4.1-1-4.2-1.6 0 0 4.4.9 8 0 0 0-.5 1.6-3.8 1.6zM15.1 11.6c.7 0 1.3-.7 1.3-1.5s-.6-1.5-1.3-1.5-1.3.7-1.3 1.5.6 1.5 1.3 1.5z"
      ></path>
    </svg>
  ),
  emojiSymbols: (props) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      width="24"
      height="24"
      {...props}
    >
      <path
        fill="currentColor"
        d="M14.5 12.9V11h2.2l-.2-1.3h-2V7.3H13v2.5h-2V7.4H9.5v2.4H7.2l.2 1.2h2.1v1.9H7.3l.2 1.3h2v2.4H11v-2.4h2v2.4h1.5v-2.4h2.3l-.2-1.3h-2.1zM11 11h2v1.9h-2V11z"
      ></path>
      <path
        fill="currentColor"
        d="M16.1 2.6H7.9C5 2.6 2.6 5 2.6 7.9V16c0 3 2.4 5.3 5.3 5.3H16c3 0 5.3-2.4 5.3-5.3V7.9c.1-2.9-2.3-5.3-5.2-5.3zm3.7 13.5c0 2.1-1.6 3.8-3.7 3.8H7.9c-2.1 0-3.8-1.7-3.8-3.8V7.9c0-2.1 1.7-3.8 3.8-3.8H16c2.1 0 3.8 1.7 3.8 3.8v8.2z"
      ></path>
    </svg>
  ),
  emojiTravel: (props) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      width="24"
      height="24"
      {...props}
    >
      <path
        fill="currentColor"
        d="M21.5 11.5c0-.7-.1-1.4-.3-2l-1.5-4.3C19.2 3.9 18 3 16.6 3H7.3c-1.4 0-2.6.9-3.1 2.2L2.6 9.9c-.1.4-.2.7-.2 1.1v8.6c0 .6.5 1.1 1.1 1.1h1.1c.6 0 1.1-.5 1.1-1.1v-1.1h12.7v1.1c0 .6.5 1.1 1.1 1.1h1.1c.6 0 1.1-.5 1.1-1.1v-7.4l-.2-.7zM4.1 10.4l1.6-4.7c.2-.7.9-1.2 1.7-1.2h9.2c.7 0 1.4.5 1.6 1.2l1.5 4.3c.1.3.2.6.2.8H4c-.1-.1 0-.3.1-.4zm1.4 5.7c-.8 0-1.5-.7-1.5-1.5s.7-1.5 1.5-1.5 1.5.7 1.5 1.5c-.1.8-.7 1.5-1.5 1.5zm9.4-.6H9.3c-.5 0-1-.4-1-1 0-.5.4-1 1-1h5.6c.5 0 1 .4 1 1-.1.6-.5 1-1 1zm3.7.6c-.8 0-1.5-.7-1.5-1.5s.7-1.5 1.5-1.5 1.5.7 1.5 1.5-.7 1.5-1.5 1.5z"
      ></path>
    </svg>
  ),
  gif: (props) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      width="24"
      height="24"
      {...props}
    >
      <path
        fill="currentColor"
        d="M13.177 12.013l-.001-.125v-.541-.512c0-.464 0-.827-.002-1.178a.723.723 0 0 0-.557-.7.715.715 0 0 0-.826.4c-.05.115-.072.253-.073.403-.003 1.065-.003 1.917-.002 3.834v.653c0 .074.003.136.009.195a.72.72 0 0 0 .57.619c.477.091.878-.242.881-.734.002-.454.003-.817.002-1.633l-.001-.681zm-3.21-.536a35.751 35.751 0 0 0-1.651-.003c-.263.005-.498.215-.565.48a.622.622 0 0 0 .276.7.833.833 0 0 0 .372.104c.179.007.32.008.649.005l.137-.001v.102c-.001.28-.001.396.003.546.001.044-.006.055-.047.081-.242.15-.518.235-.857.275-.767.091-1.466-.311-1.745-1.006a2.083 2.083 0 0 1-.117-1.08 1.64 1.64 0 0 1 1.847-1.41c.319.044.616.169.917.376.196.135.401.184.615.131a.692.692 0 0 0 .541-.562c.063-.315-.057-.579-.331-.766-.789-.542-1.701-.694-2.684-.482-2.009.433-2.978 2.537-2.173 4.378.483 1.105 1.389 1.685 2.658 1.771.803.054 1.561-.143 2.279-.579.318-.193.498-.461.508-.803.014-.52.015-1.046.001-1.578-.009-.362-.29-.669-.633-.679zM18 4.25H6A4.75 4.75 0 0 0 1.25 9v6A4.75 4.75 0 0 0 6 19.75h12A4.75 4.75 0 0 0 22.75 15V9A4.75 4.75 0 0 0 18 4.25zM21.25 15A3.25 3.25 0 0 1 18 18.25H6A3.25 3.25 0 0 1 2.75 15V9A3.25 3.25 0 0 1 6 5.75h12A3.25 3.25 0 0 1 21.25 9v6zm-2.869-6.018H15.3c-.544 0-.837.294-.837.839V14.309c0 .293.124.525.368.669.496.292 1.076-.059 1.086-.651.005-.285.006-.532.004-1.013v-.045l-.001-.46v-.052h1.096l1.053-.001a.667.667 0 0 0 .655-.478c.09-.298-.012-.607-.271-.757a.985.985 0 0 0-.468-.122 82.064 82.064 0 0 0-1.436-.006h-.05l-.523.001h-.047v-1.051h1.267l1.22-.001c.458-.001.768-.353.702-.799-.053-.338-.35-.56-.737-.561z"
      ></path>
    </svg>
  ),
  laptop: (props) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 21 18"
      width="21"
      height="18"
      {...props}
    >
      <path
        fill="currentColor"
        d="M10.426 14.235a.767.767 0 0 1-.765-.765c0-.421.344-.765.765-.765s.765.344.765.765-.344.765-.765.765zM4.309 3.529h12.235v8.412H4.309V3.529zm12.235 9.942c.841 0 1.522-.688 1.522-1.529l.008-8.412c0-.842-.689-1.53-1.53-1.53H4.309c-.841 0-1.53.688-1.53 1.529v8.412c0 .841.688 1.529 1.529 1.529H1.25c0 .842.688 1.53 1.529 1.53h15.294c.841 0 1.529-.688 1.529-1.529h-3.058z"
      ></path>
    </svg>
  ),
  lock: (props) => (
    <svg
      width="10px"
      height="12px"
      viewBox="0 0 10 12"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M5.00847986,1.6 C6.38255462,1.6 7.50937014,2.67435859 7.5940156,4.02703389 L7.59911976,4.1906399 L7.599,5.462 L7.75719976,5.46214385 C8.34167974,5.46214385 8.81591972,5.94158383 8.81591972,6.53126381 L8.81591972,9.8834238 C8.81591972,10.4731038 8.34167974,10.9525438 7.75719976,10.9525438 L2.25767996,10.9525438 C1.67527998,10.9525438 1.2,10.4731038 1.2,9.8834238 L1.2,6.53126381 C1.2,5.94158383 1.67423998,5.46214385 2.25767996,5.46214385 L2.416,5.462 L2.41679995,4.1906399 C2.41679995,2.81636129 3.49135449,1.68973395 4.84478101,1.60510326 L5.00847986,1.6 Z M5.00847986,2.84799995 C4.31163824,2.84799995 3.73624912,3.38200845 3.6709675,4.06160439 L3.6647999,4.1906399 L3.663,5.462 L6.35,5.462 L6.35111981,4.1906399 C6.35111981,3.53817142 5.88169076,2.99180999 5.26310845,2.87228506 L5.13749818,2.85416626 L5.00847986,2.84799995 Z"
        fill="currentColor"
      ></path>
    </svg>
  ),
  menu: (props) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      width="24"
      height="24"
      {...props}
    >
      <path
        fill="currentColor"
        d="M12 7a2 2 0 1 0-.001-4.001A2 2 0 0 0 12 7zm0 2a2 2 0 1 0-.001 3.999A2 2 0 0 0 12 9zm0 6a2 2 0 1 0-.001 3.999A2 2 0 0 0 12 15z"
      ></path>
    </svg>
  ),
  microphone: (props) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      width="24"
      height="24"
      {...props}
    >
      <path
        fill="currentColor"
        d="M11.999 14.942c2.001 0 3.531-1.53 3.531-3.531V4.35c0-2.001-1.53-3.531-3.531-3.531S8.469 2.35 8.469 4.35v7.061c0 2.001 1.53 3.531 3.53 3.531zm6.238-3.53c0 3.531-2.942 6.002-6.237 6.002s-6.237-2.471-6.237-6.002H3.761c0 4.001 3.178 7.297 7.061 7.885v3.884h2.354v-3.884c3.884-.588 7.061-3.884 7.061-7.885h-2z"
      ></path>
    </svg>
  ),
  notification: (props) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 48 48"
      width="48"
      height="48"
      {...props}
    >
      <path
        fill="currentColor"
        d="M24.154 2C11.919 2 2 11.924 2 24.165S11.919 46.33 24.154 46.33s22.154-9.924 22.154-22.165S36.389 2 24.154 2zm-.744 15.428v-.618c0-.706.618-1.324 1.324-1.324s1.323.618 1.323 1.324v.618c2.559.618 4.412 2.823 4.412 5.559v3.176l-8.294-8.294a5.056 5.056 0 0 1 1.235-.441zm1.323 15.706a1.77 1.77 0 0 1-1.765-1.765h3.529a1.768 1.768 0 0 1-1.764 1.765zm7.236-.883l-1.765-1.765H17.233v-.882l1.765-1.765v-4.853a5.56 5.56 0 0 1 .794-2.912l-2.559-2.559 1.147-1.147 14.735 14.736-1.146 1.147z"
      ></path>
    </svg>
  ),
  noWifi: (props) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 48 48"
      width="48"
      height="48"
      {...props}
    >
      <path
        fill="currentColor"
        d="M24.154 2C11.919 2 2 11.924 2 24.165S11.919 46.33 24.154 46.33s22.154-9.924 22.154-22.165S36.389 2 24.154 2zm-.169 32.138L12.976 19.459c3.028-2.294 6.881-3.67 11.009-3.67 4.129 0 7.982 1.376 11.009 3.67L23.985 34.138zm-.945-5.65h1.981v-1.981H23.04v1.981zm0-3.962h1.981v-5.017H23.04v5.017z"
      ></path>
    </svg>
  ),
  pinned: (props) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 19 19"
      width="19"
      height="19"
      {...props}
    >
      <path
        fill="currentColor"
        d="M9.5 18.419C4.574 18.419.581 14.426.581 9.5S4.574.581 9.5.581s8.919 3.993 8.919 8.919-3.993 8.919-8.919 8.919zm2.121-5.708l-.082-2.99 1.647-1.963a1.583 1.583 0 0 0-.188-2.232l-.32-.269a1.58 1.58 0 0 0-2.231.203L8.803 7.42l-2.964.439a.282.282 0 0 0-.14.496l5.458 4.58c.186.157.47.019.464-.224zM5.62 13.994a.504.504 0 0 0 .688-.038l2.204-2.307-1.085-.91-1.889 2.571a.504.504 0 0 0 .082.684z"
      ></path>
    </svg>
  ),
  recent: (props) => (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M20.538 11.975a8.563 8.563 0 1 0-17.126 0 8.563 8.563 0 0 0 17.126 0zm1.412 0c0 5.509-4.466 9.975-9.975 9.975C6.465 21.95 2 17.484 2 11.975 2 6.465 6.466 2 11.975 2c5.509 0 9.975 4.466 9.975 9.975zm-9.832-5.27v5.692l4.386 2.627a.706.706 0 1 1-.725 1.212l-5.073-3.04v-6.49a.706.706 0 1 1 1.412 0z"
        fill="currentColor"
      ></path>
    </svg>
  ),
  rightArrow: (props) => (
    <span
      data-testid="chevron-right-alt"
      data-icon="chevron-right-alt"
      className="pQbiR"
      {...props}
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 10 21"
        width="10"
        height="21"
      >
        <path
          fill="currentColor"
          d="M1 15.75l5.2-5.2L1 5.35l1.5-1.5 6.5 6.7-6.6 6.6-1.4-1.4z"
        ></path>
      </svg>
    </span>
  ),
  search: (props) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      width="24"
      height="24"
      {...props}
    >
      <path
        fill="currentColor"
        d="M15.009 13.805h-.636l-.22-.219a5.184 5.184 0 0 0 1.256-3.386 5.207 5.207 0 1 0-5.207 5.208 5.183 5.183 0 0 0 3.385-1.255l.221.22v.635l4.004 3.999 1.194-1.195-3.997-4.007zm-4.808 0a3.605 3.605 0 1 1 0-7.21 3.605 3.605 0 0 1 0 7.21z"
      ></path>
    </svg>
  ),
  send: (props) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      width="24"
      height="24"
      {...props}
    >
      <path
        fill="currentColor"
        d="M1.101 21.757L23.8 12.028 1.101 2.3l.011 7.912 13.623 1.816-13.623 1.817-.011 7.912z"
      ></path>
    </svg>
  ),
  singleTick: (props) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 16 15"
      width="16"
      height="15"
      {...props}
    >
      <path
        fill="currentColor"
        d="M10.91 3.316l-.478-.372a.365.365 0 0 0-.51.063L4.566 9.879a.32.32 0 0 1-.484.033L1.891 7.769a.366.366 0 0 0-.515.006l-.423.433a.364.364 0 0 0 .006.514l3.258 3.185c.143.14.361.125.484-.033l6.272-8.048a.365.365 0 0 0-.063-.51z"
      ></path>
    </svg>
  ),
  smiley: (props: any) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      width="24"
      height="24"
      {...props}
    >
      <path
        fill={props.color}
        d="M9.153 11.603c.795 0 1.439-.879 1.439-1.962s-.644-1.962-1.439-1.962-1.439.879-1.439 1.962.644 1.962 1.439 1.962zm-3.204 1.362c-.026-.307-.131 5.218 6.063 5.551 6.066-.25 6.066-5.551 6.066-5.551-6.078 1.416-12.129 0-12.129 0zm11.363 1.108s-.669 1.959-5.051 1.959c-3.505 0-5.388-1.164-5.607-1.959 0 0 5.912 1.055 10.658 0zM11.804 1.011C5.609 1.011.978 6.033.978 12.228s4.826 10.761 11.021 10.761S23.02 18.423 23.02 12.228c.001-6.195-5.021-11.217-11.216-11.217zM12 21.354c-5.273 0-9.381-3.886-9.381-9.159s3.942-9.548 9.215-9.548 9.548 4.275 9.548 9.548c-.001 5.272-4.109 9.159-9.382 9.159zm3.108-9.751c.795 0 1.439-.879 1.439-1.962s-.644-1.962-1.439-1.962-1.439.879-1.439 1.962.644 1.962 1.439 1.962z"
      ></path>
    </svg>
  ),
  status: (props) => (
    <svg
      id="df9d3429-f0ef-48b5-b5eb-f9d27b2deba6"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      width="24"
      height="24"
      {...props}
    >
      <path
        fill="currentColor"
        d="M12.072 1.761a10.05 10.05 0 0 0-9.303 5.65.977.977 0 0 0 1.756.855 8.098 8.098 0 0 1 7.496-4.553.977.977 0 1 0 .051-1.952zM1.926 13.64a10.052 10.052 0 0 0 7.461 7.925.977.977 0 0 0 .471-1.895 8.097 8.097 0 0 1-6.012-6.386.977.977 0 0 0-1.92.356zm13.729 7.454a10.053 10.053 0 0 0 6.201-8.946.976.976 0 1 0-1.951-.081v.014a8.097 8.097 0 0 1-4.997 7.209.977.977 0 0 0 .727 1.813l.02-.009z"
      ></path>
      <path fill="#009588" d="M19 1.5a3 3 0 1 1 0 6 3 3 0 0 1 0-6z"></path>
    </svg>
  ),
  sticker: (props) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      width="24"
      height="24"
      {...props}
    >
      <path
        fill="currentColor"
        d="M21.799 10.183c-.002-.184-.003-.373-.008-.548-.02-.768-.065-1.348-.173-1.939a6.6 6.6 0 0 0-.624-1.87 6.24 6.24 0 0 0-1.171-1.594 6.301 6.301 0 0 0-1.614-1.159 6.722 6.722 0 0 0-1.887-.615c-.59-.106-1.174-.15-1.961-.171-.318-.008-3.607-.012-4.631 0-.798.02-1.383.064-1.975.17a6.783 6.783 0 0 0-1.888.616 6.326 6.326 0 0 0-2.785 2.753 6.658 6.658 0 0 0-.623 1.868c-.107.591-.152 1.186-.173 1.941-.008.277-.016 2.882-.016 2.882 0 .52.008 1.647.016 1.925.02.755.066 1.349.172 1.938.126.687.33 1.3.624 1.871.303.59.698 1.126 1.173 1.595a6.318 6.318 0 0 0 1.614 1.159 6.786 6.786 0 0 0 2.146.656c.479.068.833.087 1.633.108.035.001 2.118-.024 2.578-.035a6.873 6.873 0 0 0 4.487-1.811 210.877 210.877 0 0 0 2.928-2.737 6.857 6.857 0 0 0 2.097-4.528l.066-1.052.001-.668c.001-.023-.005-.738-.006-.755zm-3.195 5.92c-.79.757-1.784 1.684-2.906 2.716a5.356 5.356 0 0 1-2.044 1.154c.051-.143.116-.276.145-.433.042-.234.06-.461.067-.74.003-.105.009-.789.009-.789.013-.483.042-.865.107-1.22.069-.379.179-.709.336-1.016.16-.311.369-.595.621-.844.254-.252.542-.458.859-.617.314-.158.65-.268 1.037-.337a8.127 8.127 0 0 1 1.253-.106s.383.001.701-.003a4.91 4.91 0 0 0 .755-.066c.186-.034.348-.105.515-.169a5.35 5.35 0 0 1-1.455 2.47zm1.663-4.757a1.128 1.128 0 0 1-.615.859 1.304 1.304 0 0 1-.371.119 3.502 3.502 0 0 1-.52.043c-.309.004-.687.004-.687.004-.613.016-1.053.049-1.502.129a5.21 5.21 0 0 0-1.447.473 4.86 4.86 0 0 0-2.141 2.115 5.088 5.088 0 0 0-.479 1.434 9.376 9.376 0 0 0-.131 1.461s-.006.684-.008.777c-.006.208-.018.37-.043.511a1.154 1.154 0 0 1-.626.86c-.072.036-.168.063-.37.098-.027.005-.25.027-.448.031-.021 0-1.157.01-1.192.009-.742-.019-1.263-.046-1.668-.126a5.27 5.27 0 0 1-1.477-.479 4.823 4.823 0 0 1-2.127-2.1 5.141 5.141 0 0 1-.482-1.453c-.09-.495-.13-1.025-.149-1.71a36.545 36.545 0 0 1-.012-.847c-.003-.292.005-3.614.012-3.879.02-.685.061-1.214.151-1.712a5.12 5.12 0 0 1 .481-1.45c.231-.449.53-.856.892-1.213.363-.36.777-.657 1.233-.886a5.26 5.26 0 0 1 1.477-.479c.503-.09 1.022-.129 1.74-.149a342.03 342.03 0 0 1 4.561 0c.717.019 1.236.058 1.737.148a5.263 5.263 0 0 1 1.476.478 4.835 4.835 0 0 1 2.126 2.098c.228.441.385.913.482 1.453.091.499.131 1.013.15 1.712.008.271.014 1.098.014 1.235a2.935 2.935 0 0 1-.037.436z"
      ></path>
    </svg>
  ),
  thumbsDown: (props) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      width="24"
      height="24"
      {...props}
    >
      <path
        fill="currentColor"
        d="M14.091 4.2H6.318c-.691 0-1.295.432-1.555 1.036l-2.591 6.132c-.086.173-.172.346-.172.605V13.7c0 .95.777 1.727 1.727 1.727h5.441L8.305 19.4v.259c0 .345.173.691.345.95l.95.864 5.7-5.7c.345-.345.518-.777.518-1.209V5.927c0-.95-.777-1.727-1.727-1.727zm3.454 0v10.364H21V4.2h-3.455z"
        id="thumb-down"
      ></path>
    </svg>
  ),
  whatsapp: (props) => (
    <svg
      fill="#000000"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      width="48px"
      height="48px"
      {...props}
    >
      <path d="M 12.011719 2 C 6.5057187 2 2.0234844 6.478375 2.0214844 11.984375 C 2.0204844 13.744375 2.4814687 15.462563 3.3554688 16.976562 L 2 22 L 7.2324219 20.763672 C 8.6914219 21.559672 10.333859 21.977516 12.005859 21.978516 L 12.009766 21.978516 C 17.514766 21.978516 21.995047 17.499141 21.998047 11.994141 C 22.000047 9.3251406 20.962172 6.8157344 19.076172 4.9277344 C 17.190172 3.0407344 14.683719 2.001 12.011719 2 z M 12.009766 4 C 14.145766 4.001 16.153109 4.8337969 17.662109 6.3417969 C 19.171109 7.8517969 20.000047 9.8581875 19.998047 11.992188 C 19.996047 16.396187 16.413812 19.978516 12.007812 19.978516 C 10.674812 19.977516 9.3544062 19.642812 8.1914062 19.007812 L 7.5175781 18.640625 L 6.7734375 18.816406 L 4.8046875 19.28125 L 5.2851562 17.496094 L 5.5019531 16.695312 L 5.0878906 15.976562 C 4.3898906 14.768562 4.0204844 13.387375 4.0214844 11.984375 C 4.0234844 7.582375 7.6067656 4 12.009766 4 z M 8.4765625 7.375 C 8.3095625 7.375 8.0395469 7.4375 7.8105469 7.6875 C 7.5815469 7.9365 6.9355469 8.5395781 6.9355469 9.7675781 C 6.9355469 10.995578 7.8300781 12.182609 7.9550781 12.349609 C 8.0790781 12.515609 9.68175 15.115234 12.21875 16.115234 C 14.32675 16.946234 14.754891 16.782234 15.212891 16.740234 C 15.670891 16.699234 16.690438 16.137687 16.898438 15.554688 C 17.106437 14.971687 17.106922 14.470187 17.044922 14.367188 C 16.982922 14.263188 16.816406 14.201172 16.566406 14.076172 C 16.317406 13.951172 15.090328 13.348625 14.861328 13.265625 C 14.632328 13.182625 14.464828 13.140625 14.298828 13.390625 C 14.132828 13.640625 13.655766 14.201187 13.509766 14.367188 C 13.363766 14.534188 13.21875 14.556641 12.96875 14.431641 C 12.71875 14.305641 11.914938 14.041406 10.960938 13.191406 C 10.218937 12.530406 9.7182656 11.714844 9.5722656 11.464844 C 9.4272656 11.215844 9.5585938 11.079078 9.6835938 10.955078 C 9.7955938 10.843078 9.9316406 10.663578 10.056641 10.517578 C 10.180641 10.371578 10.223641 10.267562 10.306641 10.101562 C 10.389641 9.9355625 10.347156 9.7890625 10.285156 9.6640625 C 10.223156 9.5390625 9.737625 8.3065 9.515625 7.8125 C 9.328625 7.3975 9.131125 7.3878594 8.953125 7.3808594 C 8.808125 7.3748594 8.6425625 7.375 8.4765625 7.375 z" />
    </svg>
  ),
  chatapp: (props) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="90px"
      height="90px"
      viewBox="0 0 90 90"
    >
      <g id="surface1">
        <path
          style={{
            stroke: "none",
            fillRule: "nonzero",
            fillOpacity: 1,
            fill: "rgb(24.313725%,70.196078%,54.117647%)"
          }}
          d="M 40.382812 38.078125 L 77.308594 38.078125 C 83.679688 38.078125 88.84375 43.242188 88.84375 49.617188 L 88.84375 68.074219 C 88.84375 73.554688 84.988281 78.28125 79.613281 79.378906 L 79.613281 88.839844 L 70.382812 79.609375 L 40.382812 79.609375 C 34.011719 79.609375 28.84375 74.445312 28.84375 68.074219 L 28.84375 49.617188 C 28.84375 43.242188 34.011719 38.078125 40.382812 38.078125 Z M 40.382812 38.078125 "
        />
        <path
          style={{
            stroke: "none",
            fillRule: "nonzero",
            fillOpacity: 1,
            fill: "rgb(7.843137%,12.156863%,21.960784%)"
          }}
          d="M 79.613281 90 C 79.308594 90 79.015625 89.878906 78.800781 89.664062 L 69.90625 80.769531 L 40.382812 80.769531 C 33.378906 80.761719 27.699219 75.082031 27.691406 68.078125 L 27.691406 49.621094 C 27.699219 42.613281 33.378906 36.933594 40.382812 36.925781 L 77.308594 36.925781 C 84.3125 36.933594 89.992188 42.609375 90 49.617188 L 90 68.074219 C 89.988281 73.746094 86.222656 78.726562 80.769531 80.285156 L 80.769531 88.839844 C 80.769531 89.476562 80.253906 89.996094 79.617188 89.996094 Z M 40.382812 39.230469 C 34.652344 39.238281 30.003906 43.882812 30 49.617188 L 30 68.074219 C 30.003906 73.804688 34.652344 78.453125 40.382812 78.457031 L 70.382812 78.457031 C 70.691406 78.457031 70.984375 78.578125 71.199219 78.796875 L 78.460938 86.058594 L 78.460938 79.378906 C 78.460938 78.828125 78.847656 78.355469 79.386719 78.246094 C 84.214844 77.25 87.683594 73.003906 87.695312 68.070312 L 87.695312 49.613281 C 87.6875 43.882812 83.042969 39.234375 77.308594 39.230469 Z M 40.382812 39.230469 "
        />
        <path
          style={{
            stroke: "none",
            fillRule: "nonzero",
            fillOpacity: 1,
            fill: "rgb(97.647059%,78.431373%,50.980392%)"
          }}
          d="M 49.617188 1.152344 L 12.691406 1.152344 C 6.320312 1.152344 1.152344 6.320312 1.152344 12.691406 L 1.152344 31.148438 C 1.152344 36.632812 5.011719 41.359375 10.382812 42.457031 L 10.382812 51.917969 L 19.613281 42.6875 L 49.617188 42.6875 C 55.988281 42.6875 61.152344 37.523438 61.152344 31.148438 L 61.152344 12.691406 C 61.15625 6.320312 55.988281 1.152344 49.617188 1.152344 Z M 49.617188 1.152344 "
        />
        <path
          style={{
            stroke: "none",
            fillRule: "nonzero",
            fillOpacity: 1,
            fill: "rgb(7.843137%,12.156863%,21.960784%)"
          }}
          d="M 10.386719 53.078125 C 9.75 53.078125 9.230469 52.5625 9.230469 51.925781 L 9.230469 43.367188 C 3.777344 41.808594 0.0117188 36.828125 0 31.152344 L 0 12.695312 C 0.00390625 5.6875 5.683594 0.0078125 12.691406 0 L 49.617188 0 C 56.621094 0.0078125 62.300781 5.6875 62.308594 12.691406 L 62.308594 31.148438 C 62.300781 38.15625 56.621094 43.835938 49.617188 43.84375 L 20.09375 43.84375 L 11.199219 52.734375 C 10.984375 52.953125 10.691406 53.074219 10.386719 53.078125 Z M 12.691406 2.308594 C 6.960938 2.316406 2.316406 6.960938 2.308594 12.691406 L 2.308594 31.148438 C 2.316406 36.082031 5.785156 40.328125 10.617188 41.324219 C 11.152344 41.433594 11.539062 41.90625 11.539062 42.457031 L 11.539062 49.136719 L 18.800781 41.875 C 19.019531 41.660156 19.3125 41.535156 19.617188 41.539062 L 49.617188 41.539062 C 55.347656 41.53125 59.996094 36.882812 60 31.152344 L 60 12.695312 C 59.996094 6.960938 55.347656 2.316406 49.617188 2.308594 Z M 12.691406 2.308594 "
        />
        <path
          style={{
            stroke: "none",
            fillRule: "nonzero",
            fillOpacity: 1,
            fill: "rgb(7.843137%,12.156863%,21.960784%)"
          }}
          d="M 75 55.386719 L 42.691406 55.386719 C 42.054688 55.386719 41.539062 54.867188 41.539062 54.230469 C 41.539062 53.59375 42.054688 53.078125 42.691406 53.078125 L 75 53.078125 C 75.636719 53.078125 76.15625 53.59375 76.15625 54.230469 C 76.15625 54.867188 75.636719 55.386719 75 55.386719 Z M 75 55.386719 "
        />
        <path
          style={{
            stroke: "none",
            fillRule: "nonzero",
            fillOpacity: 1,
            fill: "rgb(7.843137%,12.156863%,21.960784%)"
          }}
          d="M 56.539062 64.617188 L 42.691406 64.617188 C 42.054688 64.617188 41.539062 64.097656 41.539062 63.460938 C 41.539062 62.824219 42.054688 62.308594 42.691406 62.308594 L 56.539062 62.308594 C 57.175781 62.308594 57.691406 62.824219 57.691406 63.460938 C 57.691406 64.097656 57.175781 64.617188 56.539062 64.617188 Z M 56.539062 64.617188 "
        />
        <path
          style={{
            stroke: "none",
            fillRule: "nonzero",
            fillOpacity: 1,
            fill: "rgb(7.843137%,12.156863%,21.960784%)"
          }}
          d="M 47.308594 18.457031 L 15 18.457031 C 14.363281 18.457031 13.84375 17.941406 13.84375 17.304688 C 13.84375 16.664062 14.363281 16.148438 15 16.148438 L 47.308594 16.148438 C 47.945312 16.148438 48.460938 16.664062 48.460938 17.304688 C 48.460938 17.941406 47.945312 18.457031 47.308594 18.457031 Z M 47.308594 18.457031 "
        />
        <path
          style={{
            stroke: "none",
            fillRule: "nonzero",
            fillOpacity: 1,
            fill: "rgb(7.843137%,12.156863%,21.960784%)"
          }}
          d="M 28.84375 27.691406 L 15 27.691406 C 14.363281 27.691406 13.84375 27.175781 13.84375 26.539062 C 13.84375 25.902344 14.363281 25.382812 15 25.382812 L 28.84375 25.382812 C 29.484375 25.382812 30 25.902344 30 26.539062 C 30 27.175781 29.484375 27.691406 28.84375 27.691406 Z M 28.84375 27.691406 "
        />
      </g>
    </svg>
  ),
  circularLoader: (props) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="35"
      height="35"
      viewBox="0 0 40 40"
      stroke="rgb(0, 216.5, 187.0288)"
      {...props}
    >
      <g fill="none" fillRule="evenodd">
        <g transform="translate(1 1)" stroke-width="4">
          <circle stroke-opacity=".25" cx="18" cy="18" r="18" />
          <path d="M36 18c0-9.94-8.06-18-18-18">
            <animateTransform
              attributeName="transform"
              type="rotate"
              from="0 18 18"
              to="360 18 18"
              dur="1s"
              repeatCount="indefinite"
            />
          </path>
        </g>
      </g>
    </svg>
  ),
  closeIcon: (props) => (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        x="5.69727"
        y="6.28857"
        width="1.5"
        height="16.9731"
        transform="rotate(-44 5.69727 6.28857)"
        fill="white"
      ></rect>
      <rect
        x="6.29102"
        y="18.3052"
        width="1.5"
        height="16.9731"
        transform="rotate(-134 6.29102 18.3052)"
        fill="white"
      ></rect>
    </svg>
  ),
  downloadAsset: (props) => (
    <svg viewBox="0 0 34 34" width="34" height="34" className="" {...props}>
      <path
        fill="currentColor"
        d="M17 2c8.3 0 15 6.7 15 15s-6.7 15-15 15S2 25.3 2 17 8.7 2 17 2m0-1C8.2 1 1 8.2 1 17s7.2 16 16 16 16-7.2 16-16S25.8 1 17 1z"
      ></path>
      <path
        fill="currentColor"
        d="M22.4 17.5h-3.2v-6.8c0-.4-.3-.7-.7-.7h-3.2c-.4 0-.7.3-.7.7v6.8h-3.2c-.6 0-.8.4-.4.8l5 5.3c.5.7 1 .5 1.5 0l5-5.3c.7-.5.5-.8-.1-.8z"
      ></path>
    </svg>
  ),
  showTemplate: (props) => (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.99997 3.11108C10.5523 3.11108 11 3.5588 11 4.11108V6.99997H13.8889C14.4411 6.99997 14.8889 7.44769 14.8889 7.99997C14.8889 8.55226 14.4411 8.99997 13.8889 8.99997H11V11.8889C11 12.4411 10.5523 12.8889 9.99997 12.8889C9.44769 12.8889 8.99997 12.4411 8.99997 11.8889V8.99997H6.11108C5.5588 8.99997 5.11108 8.55226 5.11108 7.99997C5.11108 7.44769 5.5588 6.99997 6.11108 6.99997H8.99997V4.11108C8.99997 3.5588 9.44769 3.11108 9.99997 3.11108Z"
        fill="#424242"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3 0C2.20435 0 1.44129 0.31607 0.87868 0.87868C0.31607 1.44129 0 2.20435 0 3V19C0 19.4045 0.243642 19.7691 0.617317 19.9239C0.990991 20.0787 1.42111 19.9931 1.70711 19.7071L5.41421 16H17C17.7957 16 18.5587 15.6839 19.1213 15.1213C19.6839 14.5587 20 13.7957 20 13V3C20 2.20435 19.6839 1.44129 19.1213 0.87868C18.5587 0.31607 17.7957 0 17 0H3ZM2.29289 2.29289C2.48043 2.10536 2.73478 2 3 2H17C17.2652 2 17.5196 2.10536 17.7071 2.29289C17.8946 2.48043 18 2.73478 18 3V13C18 13.2652 17.8946 13.5196 17.7071 13.7071C17.5196 13.8946 17.2652 14 17 14H5C4.73478 14 4.48043 14.1054 4.29289 14.2929L2 16.5858V3C2 2.73478 2.10536 2.48043 2.29289 2.29289Z"
        fill="#424242"
      />
    </svg>
  ),
  activeLike: () => (
    <svg
      width="18"
      height="17"
      viewBox="0 0 18 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5.25 16H3C2.60218 16 2.22064 15.842 1.93934 15.5607C1.65804 15.2794 1.5 14.8978 1.5 14.5V9.25C1.5 8.85218 1.65804 8.47064 1.93934 8.18934C2.22064 7.90804 2.60218 7.75 3 7.75H5.25M10.5 6.25V3.25C10.5 2.65326 10.2629 2.08097 9.84099 1.65901C9.41903 1.23705 8.84674 1 8.25 1L5.25 7.75V16H13.71C14.0717 16.0041 14.4228 15.8773 14.6984 15.643C14.9741 15.4087 15.1558 15.0827 15.21 14.725L16.245 7.975C16.2776 7.76002 16.2631 7.54051 16.2025 7.33169C16.1419 7.12287 16.0366 6.92972 15.8939 6.76564C15.7512 6.60155 15.5746 6.47045 15.3762 6.38141C15.1778 6.29238 14.9624 6.24754 14.745 6.25H10.5Z"
        stroke="white"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  ),
  like: () => (
    <svg
      width="18"
      height="17"
      viewBox="0 0 18 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5.25 16H3C2.60218 16 2.22064 15.842 1.93934 15.5607C1.65804 15.2794 1.5 14.8978 1.5 14.5V9.25C1.5 8.85218 1.65804 8.47064 1.93934 8.18934C2.22064 7.90804 2.60218 7.75 3 7.75H5.25M10.5 6.25V3.25C10.5 2.65326 10.2629 2.08097 9.84099 1.65901C9.41903 1.23705 8.84674 1 8.25 1L5.25 7.75V16H13.71C14.0717 16.0041 14.4228 15.8773 14.6984 15.643C14.9741 15.4087 15.1558 15.0827 15.21 14.725L16.245 7.975C16.2776 7.76002 16.2631 7.54051 16.2025 7.33169C16.1419 7.12287 16.0366 6.92972 15.8939 6.76564C15.7512 6.60155 15.5746 6.47045 15.3762 6.38141C15.1778 6.29238 14.9624 6.24754 14.745 6.25H10.5Z"
        stroke="#424242"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  ),
  dislike: () => (
    <svg
      width="18"
      height="17"
      viewBox="0 0 18 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12.7503 1.00027H14.7528C15.1772 0.992764 15.5897 1.14137 15.9118 1.41788C16.234 1.6944 16.4434 2.07957 16.5003 2.50027V7.75027C16.4434 8.17098 16.234 8.55614 15.9118 8.83266C15.5897 9.10917 15.1772 9.25778 14.7528 9.25027H12.7503M7.50027 10.7503V13.7503C7.50027 14.347 7.73732 14.9193 8.15928 15.3413C8.58123 15.7632 9.15353 16.0003 9.75027 16.0003L12.7503 9.25027V1.00027H4.29027C3.92852 0.996182 3.57748 1.12297 3.30184 1.35727C3.02619 1.59157 2.84451 1.91759 2.79027 2.27527L1.75527 9.02527C1.72264 9.24025 1.73714 9.45976 1.79776 9.66858C1.85839 9.87741 1.96369 10.0706 2.10637 10.2346C2.24906 10.3987 2.42571 10.5298 2.62409 10.6189C2.82247 10.7079 3.03784 10.7527 3.25527 10.7503H7.50027Z"
        stroke="#424242"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  ),
  activeDislike: () => (
    <svg
      width="18"
      height="17"
      viewBox="0 0 18 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12.7503 1.00027H14.7528C15.1772 0.992764 15.5897 1.14137 15.9118 1.41788C16.234 1.6944 16.4434 2.07957 16.5003 2.50027V7.75027C16.4434 8.17098 16.234 8.55614 15.9118 8.83266C15.5897 9.10917 15.1772 9.25778 14.7528 9.25027H12.7503M7.50027 10.7503V13.7503C7.50027 14.347 7.73732 14.9193 8.15928 15.3413C8.58123 15.7632 9.15353 16.0003 9.75027 16.0003L12.7503 9.25027V1.00027H4.29027C3.92852 0.996182 3.57748 1.12297 3.30184 1.35727C3.02619 1.59157 2.84451 1.91759 2.79027 2.27527L1.75527 9.02527C1.72264 9.24025 1.73714 9.45976 1.79776 9.66858C1.85839 9.87741 1.96369 10.0706 2.10637 10.2346C2.24906 10.3987 2.42571 10.5298 2.62409 10.6189C2.82247 10.7079 3.03784 10.7527 3.25527 10.7503H7.50027Z"
        stroke="white"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  ),
  sendIcon: () => (
    <svg
      width="24"
      height="19"
      viewBox="0 0 24 19"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M23.2533 8.44061L2.25328 0.94061C1.83763 0.791563 1.37181 0.90143 1.06456 1.21966C0.757679 1.53826 0.666126 2.00701 0.830556 2.41791L3.6632 9.50006L0.830556 16.5822C0.666126 16.9931 0.757679 17.4619 1.06456 17.7805C1.28063 18.0046 1.5747 18.1251 1.87535 18.1251C2.00206 18.1251 2.12987 18.1038 2.25328 18.0595L23.2533 10.5595C23.7012 10.3995 24 9.9754 24 9.50006C24 9.02472 23.7012 8.60065 23.2533 8.44061ZM3.84593 15.1016L5.63656 10.6251L9.49437 10.6251C10.1158 10.6251 10.6194 10.1215 10.6194 9.50006C10.6194 8.8786 10.1158 8.37506 9.49437 8.37506H5.63657L3.84593 3.8985L19.53 9.50006L3.84593 15.1016Z"
        fill="#A0A0A0"
      />
    </svg>
  ),
  activeSendIcon: () => (
    <svg
      width="24"
      height="18"
      viewBox="0 0 24 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M23.2533 8.31561L2.25334 0.81561C1.83769 0.666563 1.37187 0.77643 1.06462 1.09466C0.75774 1.41326 0.666187 1.88201 0.830617 2.29291L3.66326 9.37506L0.830617 16.4572C0.666187 16.8681 0.75774 17.3369 1.06462 17.6555C1.28069 17.8796 1.57476 18.0001 1.87541 18.0001C2.00212 18.0001 2.12993 17.9788 2.25334 17.9345L23.2533 10.4345C23.7012 10.2745 24.0001 9.8504 24.0001 9.37506C24 8.89972 23.7012 8.47565 23.2533 8.31561ZM3.84599 14.9766L5.63662 10.5001L9.49443 10.5001C10.1159 10.5001 10.6194 9.99652 10.6194 9.37506C10.6194 8.7536 10.1159 8.25006 9.49443 8.25006H5.63663L3.84599 3.7735L19.5301 9.37506L3.84599 14.9766Z"
        fill="#B33027"
      />
    </svg>
  ),
  doubleDownArrow: () => (
    <svg
      width="24"
      height="30"
      viewBox="0 0 24 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <mask
        id="mask0_287_32779"
        maskUnits="userSpaceOnUse"
        x="0"
        y="6"
        width="24"
        height="24"
      >
        <rect y="6" width="24" height="24" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_287_32779)">
        <path
          d="M12 20.9748C11.8667 20.9748 11.7377 20.9498 11.613 20.8998C11.4877 20.8498 11.3833 20.7831 11.3 20.6998L6.69999 16.0998C6.51665 15.9165 6.42499 15.6831 6.42499 15.3998C6.42499 15.1165 6.51665 14.8831 6.69999 14.6998C6.88332 14.5165 7.11665 14.4248 7.39999 14.4248C7.68332 14.4248 7.91665 14.5165 8.09999 14.6998L12 18.5998L15.9 14.6998C16.0833 14.5165 16.3167 14.4248 16.6 14.4248C16.8833 14.4248 17.1167 14.5165 17.3 14.6998C17.4833 14.8831 17.575 15.1165 17.575 15.3998C17.575 15.6831 17.4833 15.9165 17.3 16.0998L12.7 20.6998C12.6 20.7998 12.4917 20.8705 12.375 20.9118C12.2583 20.9538 12.1333 20.9748 12 20.9748Z"
          fill="#455A60"
        />
      </g>
      <mask
        id="mask1_287_32779"
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="24"
        height="24"
      >
        <rect width="24" height="24" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask1_287_32779)">
        <path
          d="M12 14.9748C11.8667 14.9748 11.7377 14.9498 11.613 14.8998C11.4877 14.8498 11.3833 14.7831 11.3 14.6998L6.69999 10.0998C6.51665 9.91647 6.42499 9.68314 6.42499 9.3998C6.42499 9.11647 6.51665 8.88314 6.69999 8.6998C6.88332 8.51647 7.11665 8.4248 7.39999 8.4248C7.68332 8.4248 7.91665 8.51647 8.09999 8.6998L12 12.5998L15.9 8.6998C16.0833 8.51647 16.3167 8.4248 16.6 8.4248C16.8833 8.4248 17.1167 8.51647 17.3 8.6998C17.4833 8.88314 17.575 9.11647 17.575 9.3998C17.575 9.68314 17.4833 9.91647 17.3 10.0998L12.7 14.6998C12.6 14.7998 12.4917 14.8705 12.375 14.9118C12.2583 14.9538 12.1333 14.9748 12 14.9748Z"
          fill="#455A60"
        />
      </g>
    </svg>
  ),
  greyCross: () => (
    <svg
      width="19"
      height="19"
      viewBox="0 0 19 19"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        x="0.25"
        y="0.5"
        width="18"
        height="18"
        rx="6"
        fill="black"
        fill-opacity="0.26"
      />
      <rect
        width="12"
        height="12"
        transform="translate(3.25 3.5)"
        fill="black"
        fill-opacity="0.03"
      />
      <mask
        id="mask0_636_17906"
        maskUnits="userSpaceOnUse"
        x="3"
        y="3"
        width="13"
        height="13"
      >
        <rect x="3.25" y="3.5" width="12" height="12" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_636_17906)">
        <path
          d="M9.25 10.2452L6.64163 12.8536C6.54404 12.9512 6.41984 13 6.26901 13C6.11819 13 5.99398 12.9512 5.89639 12.8536C5.7988 12.756 5.75 12.6318 5.75 12.481C5.75 12.3302 5.7988 12.206 5.89639 12.1084L8.50475 9.5L5.89639 6.89163C5.7988 6.79404 5.75 6.66984 5.75 6.51901C5.75 6.36819 5.7988 6.24398 5.89639 6.14639C5.99398 6.0488 6.11819 6 6.26901 6C6.41984 6 6.54404 6.0488 6.64163 6.14639L9.25 8.75475L11.8584 6.14639C11.956 6.0488 12.0802 6 12.231 6C12.3818 6 12.506 6.0488 12.6036 6.14639C12.7012 6.24398 12.75 6.36819 12.75 6.51901C12.75 6.66984 12.7012 6.79404 12.6036 6.89163L9.99525 9.5L12.6036 12.1084C12.7012 12.206 12.75 12.3302 12.75 12.481C12.75 12.6318 12.7012 12.756 12.6036 12.8536C12.506 12.9512 12.3818 13 12.231 13C12.0802 13 11.956 12.9512 11.8584 12.8536L9.25 10.2452Z"
          fill="white"
        />
      </g>
    </svg>
  ),
  download: () => (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <mask
        id="mask0_697_25584"
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="24"
        height="24"
      >
        <rect width="24" height="24" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_697_25584)">
        <path
          d="M11.7129 15.6604C11.5796 15.6604 11.4546 15.6394 11.3379 15.5974C11.2212 15.5561 11.1129 15.4854 11.0129 15.3854L7.41289 11.7854C7.22956 11.6021 7.13789 11.3688 7.13789 11.0854C7.13789 10.8021 7.22956 10.5688 7.41289 10.3854C7.59622 10.2021 7.83356 10.1061 8.12489 10.0974C8.41689 10.0894 8.65456 10.1771 8.83789 10.3604L10.7129 12.2354V5.08545C10.7129 4.80212 10.8089 4.56445 11.0009 4.37245C11.1922 4.18112 11.4296 4.08545 11.7129 4.08545C11.9962 4.08545 12.2339 4.18112 12.4259 4.37245C12.6172 4.56445 12.7129 4.80212 12.7129 5.08545V12.2354L14.5879 10.3604C14.7712 10.1771 15.0089 10.0894 15.3009 10.0974C15.5922 10.1061 15.8296 10.2021 16.0129 10.3854C16.1962 10.5688 16.2879 10.8021 16.2879 11.0854C16.2879 11.3688 16.1962 11.6021 16.0129 11.7854L12.4129 15.3854C12.3129 15.4854 12.2046 15.5561 12.0879 15.5974C11.9712 15.6394 11.8462 15.6604 11.7129 15.6604ZM5.71289 20.0854C5.16289 20.0854 4.69222 19.8898 4.30089 19.4984C3.90889 19.1064 3.71289 18.6354 3.71289 18.0854V16.0854C3.71289 15.8021 3.80856 15.5644 3.99989 15.3724C4.19189 15.1811 4.42956 15.0854 4.71289 15.0854C4.99622 15.0854 5.23389 15.1811 5.42589 15.3724C5.61722 15.5644 5.71289 15.8021 5.71289 16.0854V18.0854H17.7129V16.0854C17.7129 15.8021 17.8089 15.5644 18.0009 15.3724C18.1922 15.1811 18.4296 15.0854 18.7129 15.0854C18.9962 15.0854 19.2336 15.1811 19.4249 15.3724C19.6169 15.5644 19.7129 15.8021 19.7129 16.0854V18.0854C19.7129 18.6354 19.5172 19.1064 19.1259 19.4984C18.7339 19.8898 18.2629 20.0854 17.7129 20.0854H5.71289Z"
          fill="white"
        />
      </g>
    </svg>
  ),
  redirect: () => (
    <svg
      width="12"
      height="13"
      viewBox="0 0 12 13"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1.33333 12.5C0.966667 12.5 0.652667 12.3696 0.391333 12.1087C0.130444 11.8473 0 11.5333 0 11.1667V1.83333C0 1.46667 0.130444 1.15267 0.391333 0.891333C0.652667 0.630444 0.966667 0.5 1.33333 0.5H5.33333C5.52222 0.5 5.68067 0.563778 5.80867 0.691333C5.93622 0.819333 6 0.977778 6 1.16667C6 1.35556 5.93622 1.51378 5.80867 1.64133C5.68067 1.76933 5.52222 1.83333 5.33333 1.83333H1.33333V11.1667H10.6667V7.16667C10.6667 6.97778 10.7307 6.81933 10.8587 6.69133C10.9862 6.56378 11.1444 6.5 11.3333 6.5C11.5222 6.5 11.6804 6.56378 11.808 6.69133C11.936 6.81933 12 6.97778 12 7.16667V11.1667C12 11.5333 11.8696 11.8473 11.6087 12.1087C11.3473 12.3696 11.0333 12.5 10.6667 12.5H1.33333ZM4 8.5C3.87778 8.37778 3.81667 8.22222 3.81667 8.03333C3.81667 7.84444 3.87778 7.68889 4 7.56667L9.73333 1.83333H8C7.81111 1.83333 7.65289 1.76933 7.52533 1.64133C7.39733 1.51378 7.33333 1.35556 7.33333 1.16667C7.33333 0.977778 7.39733 0.819333 7.52533 0.691333C7.65289 0.563778 7.81111 0.5 8 0.5H11.3333C11.5222 0.5 11.6804 0.563778 11.808 0.691333C11.936 0.819333 12 0.977778 12 1.16667V4.5C12 4.68889 11.936 4.84711 11.808 4.97467C11.6804 5.10267 11.5222 5.16667 11.3333 5.16667C11.1444 5.16667 10.9862 5.10267 10.8587 4.97467C10.7307 4.84711 10.6667 4.68889 10.6667 4.5V2.76667L4.91667 8.51667C4.79444 8.63889 4.64444 8.7 4.46667 8.7C4.28889 8.7 4.13333 8.63333 4 8.5Z"
        fill="#B33027"
      />
    </svg>
  ),
  websiteBack: () => (
    <svg
      width="24"
      height="25"
      viewBox="0 0 24 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <mask
        id="mask0_812_16744"
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="24"
        height="25"
      >
        <rect y="0.5" width="24" height="24" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_812_16744)">
        <path
          d="M7.99289 18.2047L3.28165 13.2651C3.17923 13.1577 3.10686 13.0414 3.06452 12.9161C3.02151 12.7908 3 12.6566 3 12.5134C3 12.3702 3.02151 12.236 3.06452 12.1107C3.10686 11.9855 3.17923 11.8691 3.28165 11.7617L8.01849 6.7953C8.20626 6.59843 8.4367 6.5 8.70982 6.5C8.98293 6.5 9.22191 6.60738 9.42674 6.82215C9.61451 7.01902 9.70839 7.26957 9.70839 7.57383C9.70839 7.87808 9.61451 8.12864 9.42674 8.3255L6.45661 11.4396H19.9758C20.266 11.4396 20.5091 11.5423 20.705 11.7478C20.9017 11.954 21 12.2092 21 12.5134C21 12.8177 20.9017 13.0725 20.705 13.278C20.5091 13.4842 20.266 13.5872 19.9758 13.5872H6.45661L9.45235 16.7282C9.64011 16.9251 9.734 17.1667 9.734 17.453C9.734 17.7394 9.63158 17.9899 9.42674 18.2047C9.23898 18.4016 9 18.5 8.70982 18.5C8.41963 18.5 8.18065 18.4016 7.99289 18.2047Z"
          fill="#E03C31"
        />
      </g>
    </svg>
  )
};

// name: (props) => (),

export default icons;
